// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/* Variables */\n\n/* Mixins */\n.admin-textarea textarea {\n  padding-right: 40px;\n  resize: none;\n  border: none;\n  border-radius: 0px;\n  border-bottom: 1px solid #bfcbd9;\n}", ""]);
// Exports
exports.locals = {
	"menuBg": "#b58643",
	"menuText": "#e0e0e0",
	"menuActiveText": "#ffe164",
	"menuActiveBg": "#906a35"
};
module.exports = exports;
